import type { HttpGetBlob } from '@/shared/infra/http'
import { mapServerError } from '@/shared/infra/http'
import type { DownloadSignatureRequestPdf } from '@/shared/domain'

export class SupabaseDownloadSignatureRequestPdfRepository {
  constructor(private readonly http: HttpGetBlob) {}

  execute: DownloadSignatureRequestPdf = async ({ id }) => {
    try {
      return await this.http.getBlob({
        url: `/signature-requests/${encodeURIComponent(id)}/pdf`,
      })
    } catch (error) {
      mapServerError(error)
    }
  }
}
